import { Autocomplete, Stack, TextField } from "@mui/material";
import { prettyPrintDocumentType } from "encamp-shared/src/utils/prettyPrintDocumentType";
import { DocumentType } from "generated-graphql/graphql";

type FacilityDocumentTypePickerProps = {
  documentTypes: DocumentType[];
  selectedDocumentType?: DocumentType;
  onSelectDocumentType?: (documentType: DocumentType) => void;
};

export const FacilityDocumentTypePicker = ({
  documentTypes,
  selectedDocumentType,
  onSelectDocumentType,
}: FacilityDocumentTypePickerProps) => {
  return (
    <Stack spacing={1}>
      <Autocomplete
        options={documentTypes}
        value={selectedDocumentType ?? null}
        getOptionLabel={(type) => prettyPrintDocumentType(type)}
        disableClearable={selectedDocumentType !== undefined}
        onChange={(_, type) => {
          if (type) {
            onSelectDocumentType?.(type);
          }
        }}
        renderInput={(params) => <TextField {...params} label="Document Type" required />}
      />
    </Stack>
  );
};
